<template>
    <button
        class="trigger-bestseller-view"
        data-tracking="machine_sheet__button__best_seller_tab"
        @click="$emit('trigger')"
    ></button>
</template>

<script>
    export default {
        name: 'BestSellerTrigger'
    }
</script>

<style lang="scss">
    $svg-height: 410px;

    .trigger-bestseller-view {
        position: fixed;
        top: calc(#{$product-sheet-title-height} + #{$product-sheet-navigation-height} + 100px + (#{$svg-height} / 2)); // header title + header nav + margin + half svg vertical size
        right: -10px;
        z-index: 5;
        display: inline-block;
        width: 51px;
        height: $svg-height;
        margin-top: calc(-#{$svg-height} / 2);
        background-image: url('~@/assets/img/best-seller-trigger.svg');
        background-repeat: no-repeat;
        text-indent: -9999px;
        cursor: pointer;
        transition: right 0.3s ease;

        @media #{$mq_phone} {
            display: none;
        }

        &:hover {
            right: -5px;
        }
    }
</style>
